const tabsActivationModeOptions = {
  MANUAL: 'manual',
  AUTOMATIC: 'automatic'
}

const makeTriggerId = (baseId, value) => `${baseId}-trigger-${value}`

const makeContentId = (baseId, value) => `${baseId}-content-${value}`

export {
  tabsActivationModeOptions,
  makeTriggerId,
  makeContentId
}
